import { createContext, useContext } from "react";

// Lets a node deep inside the recursive OrgDesignChartNode tree (an
// OrgDesignRoleBoxNode, several levels down) silence OrgTreeCard's scroll
// reporting for the entire span of its own collapse-toggle reflow — e.g.
// re-anchoring after the toggle shrinks the tree (bug #1910) — so that
// neither the browser's own scrollLeft/scrollTop clamp (which fires
// immediately on the reflow, before any correction runs) nor the eventual
// corrective write gets mistaken by OrgTreeCard's scroll listener for a
// real user pan and mirrored onto the sibling Current/Proposed card (see
// OrgTreeCard's beginScrollCorrection/endScrollCorrection, the only place
// that's allowed to happen). A plain prop would have to be threaded through
// every recursive level of OrgDesignChartNode just to reach
// OrgDesignRoleBoxNode; context skips that.
//
// The context value is `{ begin, end } | null`:
//   - begin() — call before the toggle, so even the browser's own
//     immediate clamp is covered.
//   - end(deltaLeft, deltaTop) — call once the correction has been
//     measured (after both rAFs); applies it and re-enables reporting.
// Consumers with no provider above them (the read-only PAIC import
// preview's TreePreviewStyled has no sibling to keep in sync) get `null`
// back and fall back to adjusting their own nearest scroll container
// directly — see useCollapseScrollAnchor.
const OrgTreeScrollCorrectionContext = createContext(null);

export const OrgTreeScrollCorrectionProvider = OrgTreeScrollCorrectionContext.Provider;

export const useOrgTreeScrollCorrection = () => useContext(OrgTreeScrollCorrectionContext);
